import { render, staticRenderFns } from "./FooterCollapsible.vue?vue&type=template&id=45b1f5dc&scoped=true&"
import script from "./FooterCollapsible.vue?vue&type=script&lang=js&"
export * from "./FooterCollapsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1f5dc",
  null
  
)

export default component.exports